import { EUserGroupsListActions, UserGroupListActions } from '../actions/user-groups-list.actions';

export const initialUserGroupsListState: IUserGroupsList = {
  isLoading: false,
  userGroupsToDelete: [],
  userGroupList: []
}

export function userGroupsListReducers(state = initialUserGroupsListState, action: UserGroupListActions): IUserGroupsList {
  switch (action.type) {
    case EUserGroupsListActions.GetUserGroupsSuccess: {
      const newState = {
        ...state,
        userGroupList: action.payload
      };
      return newState;
    }

    case EUserGroupsListActions.DeleteUserGroups: {
      const newState = {
        ...state,
        deleting: true,
        userGroupsToDelete: action.payload
      };
      return newState;
    }

    case EUserGroupsListActions.DeleteUserGroupsSuccess: {
      const newState = {
        ...state,
        deleting: false,
        userGroupsToDelete: []
      };
      return newState;
    }

    case EUserGroupsListActions.ResetUserGroupsSuccess: {
      return initialUserGroupsListState;
    }

    default:
      return state;
  }
};

export const selectUserGroupsList = (state: IUserGroupState) => state.userGroupList;